
import React from 'react';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { RefreshCw } from 'lucide-react';

interface ChatHeaderProps {
  chatbotName: string;
  chatbotAvatar: string;
  onClearChat: () => void;
}

const ChatHeader = ({ chatbotName, chatbotAvatar, onClearChat }: ChatHeaderProps) => {
  return (
    <div className="p-4 border-b flex justify-between items-center">
      <div className="flex items-center gap-3">
        <Avatar className="h-9 w-9">
          <AvatarImage src={chatbotAvatar} alt={chatbotName} />
          <AvatarFallback>{chatbotName.substring(0, 2)}</AvatarFallback>
        </Avatar>
        <span className="font-medium">{chatbotName}</span>
      </div>
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={onClearChat}
        className="text-muted-foreground hover:text-foreground"
      >
        <RefreshCw size={16} className="mr-2" />
        Clear Chat
      </Button>
    </div>
  );
};

export default ChatHeader;
